"use client";

import React from "react";
import { Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const terms = [{
  title: "Custom Website Design",
  content: "Every project receives a unique, modern design tailored to your specific trade or small business, ensuring you stand out from the competition with a premium digital presence."
}, {
  title: "Professional Hosting",
  content: "We provide 12 months of high-speed hosting with every build, ensuring your website remains fast, secure, and accessible for all visitors 24/7."
}, {
  title: "Domain Registration",
  content: "Your package includes 12 months of domain registration. We handle the technical setup and renewals so you can focus on running your business."
}, {
  title: "Page Limits & Structure",
  content: "Starter packages include up to 3 custom pages, while Advanced packages offer up to 5 pages to accommodate more detailed service descriptions and business information."
}, {
  title: "Mobile Responsive Design",
  content: "All our websites are built with a mobile-first approach, ensuring a seamless and professional experience for customers browsing on smartphones, tablets, and desktops."
}, {
  title: "Search Engine Optimisation",
  content: "Basic SEO optimisation is built into every site to help your business get discovered by local customers searching for your specific services online."
}, {
  title: "Contact Form Integration",
  content: "We integrate professional contact forms to capture leads directly from your site, making it easy for potential customers to request quotes or information."
}, {
  title: "Click-to-Call Integration",
  content: "For trades on the move, we ensure your phone number is clickable across the site, allowing mobile customers to call your business with a single tap."
}, {
  title: "Monthly Content Updates",
  content: "Stay current with ongoing updates. Starter packages include 2 content changes per month, while Advanced packages include 5 monthly updates to keep your site fresh."
}, {
  title: "Unlimited Technical Support",
  content: "We offer unlimited technical support calls to help you with any questions regarding your website's performance, email configuration, or general setup."
}, {
  title: "Design Revision Rounds",
  content: "To ensure you love the final product, we include two rounds of design revisions in our Starter package and comprehensive reviews for our Advanced builds."
}, {
  title: "Content Revision Rounds",
  content: "We provide dedicated rounds of content revisions to fine-tune your messaging and ensure all business information and service details are 100% accurate."
}, {
  title: "Branding & Strategy Sessions",
  content: "Advanced packages include a professional 1-hour branding session to define your visual identity and align your new website with your long-term business goals."
}, {
  title: "Professional Content Creation",
  content: "Our optional add-on provides professional photography, videography, and drone footage to give your website a premium, custom look that generic templates can't match."
}];
export default function FullTermsContent() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}